import { Text } from 'src/Components'
import Format from 'src/Components/shared/Format'
import { defineMessages, useIntl } from 'react-intl'

import styles from './PocketAmountAndMortgageDiff.module.scss'

export const MSG = defineMessages({
  pocket: {
    id: 'MarketSpotLight.equitySmartSearch.pocket',
    defaultMessage: 'pocket',
  },
  save: {
    id: 'MarketSpotLight.equitySmartSearch.save',
    defaultMessage: 'save about',
  },
  extra: {
    id: 'MarketSpotLight.equitySmartSearch.aboutAnExtra',
    defaultMessage: 'about an extra',
  },
  perMonth: {
    id: 'MarketSpotLight.equitySmartSearch.perMonth',
    defaultMessage: '/month',
  },
})

export interface PocketAmountAndMortgageDiffProps {
  pocketAmount: number
  mortgagePaymentDifference: number
}

export const PocketAmountAndMortgageDiff = ({
  pocketAmount,
  mortgagePaymentDifference,
}: PocketAmountAndMortgageDiffProps) => {
  const intl = useIntl()

  return (
    <div className={styles.calculationsContainer}>
      <div className={styles.pocketAmountContainer}>
        <Text
          size='xxs'
          element='div'
          variantCount='700'
          variant='neutralCool'
          transform='uppercase'
          className={styles.pocketAmountText}
        >
          {intl.formatMessage(MSG.pocket)}
        </Text>
        <Text
          size='l'
          variant='success'
          variantCount='700'
          className={styles.pocketAmount}
        >
          <Format.Currency value={pocketAmount} abbreviate />
        </Text>
      </div>
      <div className={styles.mortgagePaymentDifferenceContainer}>
        <Text
          size='xxs'
          element='div'
          variantCount='600'
          variant='neutralCool'
          transform='uppercase'
          className={styles.savingsText}
        >
          {mortgagePaymentDifference <= 0
            ? intl.formatMessage(MSG.save)
            : intl.formatMessage(MSG.extra)}
        </Text>
        <div className={styles.savingsContainer}>
          <Text
            size='l'
            variantCount='700'
            className={styles.savingsAmount}
            variant={mortgagePaymentDifference <= 0 ? 'success' : 'danger'}
          >
            <Format.Currency
              abbreviate
              value={Math.abs(mortgagePaymentDifference)}
            />
            {intl.formatMessage(MSG.perMonth)}
          </Text>
        </div>
      </div>
    </div>
  )
}
